import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DEFAULT_TOOLTIP_THRESHOLD = 23;

interface TooltipButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  className: string;
  activeClassName: string;
  tooltipThreshold?: number;
}

export function TooltipButton({
  label,
  isActive,
  onClick,
  className,
  activeClassName,
  tooltipThreshold = DEFAULT_TOOLTIP_THRESHOLD,
}: TooltipButtonProps) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="auto"
      overlay={
        label.length > tooltipThreshold ? <Tooltip>{label}</Tooltip> : <></>
      }
    >
      <button
        className={`${className} ${isActive ? activeClassName : ''}`}
        aria-pressed={isActive}
        onClick={onClick}
      >
        {label}
      </button>
    </OverlayTrigger>
  );
}
